module.exports = __webpack_public_path__ + "img/houseWorkorder.f8b0660d.svg";